/**
 * This script is used to notify Bloomreach of page views and clicks.
 */

export const allowedDomains = ['ameriprise.com']

export const isValidUrl = (url, allowedDomains) => {
  try {
    const parsedUrl = new URL(url)
    if (parsedUrl.protocol !== 'https:') {
      return false
    }

    return allowedDomains.some(domain => parsedUrl.hostname.endsWith(domain))
  } catch (e) {
    return false
  }
}

export const sanitizeUrl = (url, origin) => {
  try {
    const parsedUrl = new URL(url, origin)
    if (parsedUrl.origin !== origin) {
      throw new Error('Invalid URL')
    }
    return parsedUrl.href
  } catch (e) {
    return origin
  }
}

export const getNotifyUrl = (url, notifyUrl, origin) => {
  url = sanitizeUrl(url, origin)
  if (url.startsWith('/')) {
    url = origin + url
  }
  if (url.indexOf('?') !== -1) {
    url = url.substring(0, url.indexOf('?'))
  }
  if (url.indexOf('#') !== -1) {
    url = url.substring(0, url.indexOf('#'))
  }
  if (url.endsWith('/')) {
    url = url.substring(0, url.length - 1)
  }
  return notifyUrl + '?url=' + url
}

export const notifyPageView = (url, notifyUrl, allowedDomains, fetchFn) => {
  const fullNotifyUrl = getNotifyUrl(url, notifyUrl, window.location.origin)
  if (isValidUrl(fullNotifyUrl, allowedDomains)) {
    fetchFn(fullNotifyUrl)
  } else {
    console.error('Invalid brxm analytics notify page view URL')
  }
}

export const handleClickEvent = (
  e,
  notifyUrl,
  allowedDomains,
  sendBeaconFn
) => {
  if (
    e === undefined ||
    (Object.keys(e).length === 0 && e.constructor === Object) ||
    (e.path === undefined && e.composedPath() === undefined)
  ) {
    return
  }

  const elements = e.path || e.composedPath()

  for (let element of elements) {
    if (!element.hasAttribute('href')) {
      return
    }

    const href = element.getAttribute('href')
    const location = getNotifyUrl(
      window.location.href,
      notifyUrl,
      window.location.origin
    )
    const notification = getNotifyUrl(href, notifyUrl, window.location.origin)
    if (notification === '' || notification === location) {
      return
    }

    sendBeaconFn(notification)
  }
}
;(function (window) {
  if (!window.brxmNotifyUrl) {
    return
  }

  const notifyUrl = window.brxmNotifyUrl

  if (window.fetch) {
    notifyPageView(
      window.location.href,
      notifyUrl,
      allowedDomains,
      window.fetch
    )
  }

  if (!navigator.sendBeacon) {
    return
  }

  window.addEventListener('click', e =>
    handleClickEvent(e, notifyUrl, allowedDomains, navigator.sendBeacon)
  )
})(window)
